const NULLABLE = [null, undefined, NaN];
const EMPTY = NULLABLE.concat('');

export default function nullable(value) {
  return NULLABLE.includes(value);
}

export function empty(value) {
  return EMPTY.includes(typeof value === 'string' ? value.trim() : value);
}

export function fallback(value, replace) {
  return empty(value) ? replace : value;
}
